import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { GlassCard } from '../components/ui';
import { ITSupportForm } from '../components/forms/ITSupportForm';

export function ITSupportPage() {
  return (
    <div className="min-h-screen flex flex-col w-full min-w-0">
      <Header showBackButton backHref="/portal" />

      <main className="flex-1 w-full min-w-0 container mx-auto px-4 py-8 pb-16 max-w-6xl">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">IT Support Request</h1>
          <p className="text-gray-600">
            Submit a request for IT assistance — hardware, software, access, and general technical support.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <GlassCard className="p-6 md:p-8" hoverable={false}>
            <ITSupportForm />
          </GlassCard>
        </div>
      </main>

      <Footer />
    </div>
  );
}
